<template>
  <h1 v-if="dados.length == 0" class="textoNotificacao">{{mensagemSemDados}}</h1>
  <table class="table is-striped is-narrow is-hoverable is-fullwidth trf-sticky-table-header" v-else>
      <thead v-if="configuracaoDeColunas.length > 0">
        <tr>
          <th v-if="isCliente || isToggleble">
            <input
              v-if="checboxSelectAll"
              type="checkbox"
              :checked="isAllCheckboxChecked"
              @change="checkAllCheckbox"
            /> 
          </th>
          <th
            v-for="(coluna, index) in configuracaoDeColunas"
            :key="index"
            :style="`${coluna.customStyle}`"
            @click="() => _ordenar(coluna)"
            :class="{'is-clickable' : coluna.isSortable }"
          >
            <div :class="{ 'is-sortable': coluna.isSortable }">
              {{coluna.titulo}}
              <div v-if="coluna.isSortable" style="display: flex; flex-direction: column; margin-top: -2px;">
                <i v-show="sort.titulo != coluna.titulo || sort.ordenacao != ordenacaoEnum.DECRESCENTE" class="mdi mdi-menu-up" style="height: 5px;"></i>
                <i v-show="sort.titulo != coluna.titulo || sort.ordenacao != ordenacaoEnum.CRESCENTE" class="mdi mdi-menu-down" style="height: 5px;"></i>
              </div>
            </div>
          </th>
          <slot name="th"></slot>
        </tr>
      </thead>
      <tbody>
        <template
          v-for="(item, itemIndex) in dados" 
          :key="`linha-${itemIndex}`"
        >
          <tr 
            :class="{ 'is-toggled': toggleStatus[!!item.id? item.id : itemIndex] }"
            @dblclick="$emit('duploClick', item)"
          >
            <td v-if="(this.isSelectable && this.isMultipleSelection) || isToggleble || isCliente">
              <span class="is-flex">
                <input
                  v-if="isCliente"
                  type="checkbox"
                  id="checkbox"
                  @change="e => checkCheckbox(e, item.id)"
                  :checked="checkedItens[item.id]"
                  :disabled="!item.showCheckboxDownload"
                />

                <label 
                  v-if="isToggleble && !!item && !!item[togglebleItem]"
                  :class="{
                    'checkbox': true,
                    'is-toggle-action': true,
                    'is-toggle-show': toggleStatus[!!item.id ? item.id : itemIndex],
                    'is-toggle-hide': !toggleStatus[!!item.id ? item.id : itemIndex]
                  }" 
                  @click="(event) => event.stopPropagation()"
                >
                  <input
                    type="checkbox"
                    v-model="toggleStatus[!!item.id ? item.id : itemIndex]"
                    :checked="toggleStatus[!!item.id ? item.id : itemIndex]"
                    id="hiddenCheckbox"
                  />
                  <span class="icon is-small" :class="{'has-text-primary': true, 'has-text-white': false}">
                    <i class="mdi mdi-24px mdi-chevron-right ml-3" style="transition: transform 0.25s ease 0s; margin-top:-3px" :style="{'transform': toggleStatus[!!item.id ? item.id : itemIndex]? 'rotate(90deg)' : 'rotate(0deg)'}" aria-hidden="true"></i>
                  </span>
                </label>
              </span>
            </td>
            <template v-for="(coluna, colunaIndex) in configuracaoDeColunas" :key="`coluna-${colunaIndex}`">
              <td>
                <template v-if="coluna.slot">
                  <slot :name="coluna.nome" :item="!!item ? item : itemIndex" :index="itemIndex"></slot>
                </template>
                <template v-else>
                  {{this._comporDados(item, coluna.referencia, coluna.divisor, coluna.placeholder)}}
                </template>
              </td>
            </template>
            <slot name="td" :item="item"></slot>
          </tr>
        <slot
          v-if="hasSlotLine"
          name="slotLine"
          :item="!!item? item : null"
        ></slot>
        </template>
      </tbody>
      <slot name="tfoot"></slot>
  </table>
</template>

<script>
import { ordenacaoEnum } from '../../enums/ordenacaoEnum';

export default {
  name: "TrfSimpleTable",
  props: {
    configuracaoDeColunas: {
      type: Array,
      default: new Array()
    },
    dados: {
      type: Array,
      default: new Array()
    },
    status: String,
    isCliente: Boolean,
    mensagemSemDados: {
      type: String,
      default: "Não há dados para esta tabela."
    },
    hasSlotLine : {
      type: Boolean,
      default: false
    },
    isToggleble : {
      type: Boolean,
      default: false
    },
    togglebleItem : {
      type: String
    },
    isSelectable : {
      type: Boolean,
      default: true
    },
    isMultipleSelection : {
      type: Boolean,
      default: false
    },
    checboxSelectAll: {
      type: Boolean,
      default: false
    },
    alreadyCheckedItens: {
      type: Array,
      default: new Array(),
    }
  },

  emits: ['checkbox-change', 'duploClick'],

  data() {
    return {
      checkedItens: {},
      statusAtual: 'vazio',
      toggleStatus: [],
      sort: {
        titulo: '',
        ordenacao: ordenacaoEnum.NENHUMA
      },
      ordenacaoEnum
    };
  },

  methods: {
    checkAllCheckbox(e) {
      const isChecked = e.target.checked;
      for(let i in this.dados) {
        this.checkedItens[this.dados[i].id] = isChecked;
      }
      this.emitCheckboxChange();
    },
    checkCheckbox(e, id) {
      const isChecked = e.target.checked;
      this.checkedItens[id] = isChecked;
      this.emitCheckboxChange();
    },
    emitCheckboxChange() {
      const ids = Object.entries(this.checkedItens).filter(([, value]) => value).map(([key, ]) => key);
      this.$emit('checkbox-change', ids);
    },

    _comporDados(item, referencias, divisor, placeholder = "- - -") {
      if(!!!item || referencias.length == 0) return;

      let resultado = '';
      if(referencias.length == 1) {
        resultado = this._adquirirValorDoObjeto(item, referencias[0]);
        return resultado || placeholder;
      }

      for(let referencia in referencias) {
        if(referencia == 0) {
          resultado = `${resultado}${this._adquirirValorDoObjeto(item,referencias[referencia])}`;
        } else {
          resultado = `${resultado}${divisor}${this._adquirirValorDoObjeto(item,referencias[referencia])}`;
        }
      }

      return resultado || placeholder;
    },
    _adquirirValorDoObjeto(item, referencia) {
      const caminhos = referencia.split(".");
      let valor = item;
      for (let caminho of caminhos) {
        if (!!!valor[caminho]) {
          valor = null;
          break
        };
        valor = valor[caminho];
      }

      return valor || '';
    },
    _ordenar(coluna) {
      if(!coluna.isSortable) {
        return;
      }

      if(this.sort.titulo != coluna.titulo) {
        this.sort.titulo = coluna.titulo;
        this.sort.ordenacao = ordenacaoEnum.CRESCENTE;
        coluna.sort(this.sort.ordenacao);
        return;
      }

      this.toggleOrdenacao();
      coluna.sort(this.sort.ordenacao);
    },
    toggleOrdenacao() {
      return this.sort.ordenacao == ordenacaoEnum.DECRESCENTE ?
        this.sort.ordenacao = ordenacaoEnum.CRESCENTE :
        this.sort.ordenacao = ordenacaoEnum.DECRESCENTE
    },
    limparCheckedBox() {
      this.checkedItens = {};
    }
  },
  computed: {
    isAllCheckboxChecked: {
      get() {
        const checkboxsNotChecked = this.dados.filter(d => !this.alreadyCheckedItens.includes(d.id));
        return checkboxsNotChecked.length == 0;
      }, set(value) {}
    }
  },
  watch: {
    status: {
      immediate: true,
      handler() {
        this.statusAtual = this.status;
      }
    },
    dados: {
      immediate: true,
      handler(novo, antigo) {
        if(novo == antigo) return;
        if(this.sort.titulo == '') return;
        const coluna = this.configuracaoDeColunas.find(c => c.titulo == this.sort.titulo);
        coluna.sort(this.sort.ordenacao);
      }
    }
  },
  beforeMount() {
    this.dados.forEach(d => this.checkedItens[d.id] = false);
    this.alreadyCheckedItens.forEach(id => this.checkedItens[id] = true);
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/sass/variables.scss";

.trf-sticky-table-header {
  border-collapse: separate;
  & > thead > tr:first-child {
    & > th {
      position: sticky;
      top: 0;
      background-color:var(--white, #FFF);
      border-bottom-width: 2px;
      z-index: 1;
    }
  }
  & > tbody:first-of-type > tr:first-child > td {
    border-top-width: 0;
  }
}

.is-sortable {
  display: flex;
  justify-content: space-between;
}

.textoNotificacao {
  margin: 9% 0 15% 0;
  text-align: center;
  font-size: 21px;
  color: #31708f;
}
</style>

<style lang="scss">
.trf-sticky-table-header  th, .trf-sticky-table-header td {
  vertical-align: middle;
}

#hiddenCheckbox {
  display: none;
}
</style>